import { render, staticRenderFns } from "./ticket-owners-accordion.vue?vue&type=template&id=5703584c&scoped=true"
import script from "./ticket-owners-accordion.vue?vue&type=script&lang=js"
export * from "./ticket-owners-accordion.vue?vue&type=script&lang=js"
import style0 from "./ticket-owners-accordion.vue?vue&type=style&index=0&id=5703584c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703584c",
  null
  
)

export default component.exports